export { default } from './TabPanel';
export * from './tabPanelClasses';
export { default as tabPanelClasses } from './tabPanelClasses';
export * from './TabPanelProps';
